import { useElements } from "@/hooks/useElementsProvider";
import UIElement from "./elements/UIElement";
import { Alert, AlertTitle } from "./ui/alert";
import { cn } from "@/lib/utils";

export const ElementsContainer = () => {
  const { editMode, elements } = useElements();

  const root = Object.values(elements).find(
    element => element.parentId === null,
  );

  return (
    <div
      className={cn("relative flex flex-1 flex-col overflow-y-auto", {
        "mt-4 max-h-[calc(100vh-2rem)] rounded-lg shadow-2xl": editMode,
      })}
    >
      {root ? (
        <UIElement element={root} key={root.id} id={root.id} isInGrid={false} />
      ) : (
        <Alert variant="destructive">
          <AlertTitle>No root element found</AlertTitle>
        </Alert>
      )}
    </div>
  );
};
